module.exports = __webpack_public_path__ + "img/ar-view-logo.1a03baba.svg";